import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33e2bbdf&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./treatmentPeriodDetails.styles.scss?vue&type=style&index=0&id=33e2bbdf&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e2bbdf",
  null
  
)

export default component.exports